import { ProductGuideStep } from 'models/ProductGuideStep';
import { Section } from 'components/Section';
import { Grid } from 'components/Grid';
import { hasElements, NO_ELEMENT } from 'utils';

interface OwnProps {
  title: string;
  url?: string;
  showHero?: boolean;
  steps: ProductGuideStep[];
}

export const ProductGuideContainer = ({ title, steps }: OwnProps) => {
  if (!hasElements(steps)) {
    return NO_ELEMENT;
  }

  return (
    <Section title={<h1>{title}</h1>}>
      <Grid huge="8" desktop="6" large="5" tablet="4" phone="3">
        {/* Här ska producktvalsguid paketet in när det är klart. */}
      </Grid>
    </Section>
  );
};
